module.exports = __webpack_public_path__ + "media/mypage/images/bgservice-9210f47b4e34a0cad1367cf79babe963.jpg";